import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-gpt-five',
  templateUrl: './gpt-five.component.html',
  styleUrls: ['./gpt-five.component.scss']
})
export class GptFiveComponent {
  constructor(private dialogRef: MatDialogRef<GptFiveComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
